import { useEffect, useState } from "react";

/**
 * Returns a copy of `value` that only updates after `delay` ms of no changes.
 * Useful for filter-bar search inputs where every keystroke would otherwise
 * trigger a server refetch.
 *
 * @example
 *   const [search, setSearch] = useState("");
 *   const debouncedSearch = useDebouncedValue(search, 300);
 *   const { data } = useQuery({ queryKey: ["x", debouncedSearch], … });
 */
export function useDebouncedValue<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);
  return debounced;
}
